module.exports = require("css.escape");


//////////////////
// WEBPACK FOOTER
// external "css.escape"
// module id = 521
// module chunks = 0